import { render, staticRenderFns } from "./ContactsPopup.component.vue?vue&type=template&id=7613e744"
import script from "./ContactsPopup.component.vue?vue&type=script&lang=js"
export * from "./ContactsPopup.component.vue?vue&type=script&lang=js"
import style0 from "./ContactsPopup.component.vue?vue&type=style&index=0&id=7613e744&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports